var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-with-image"},[_c('div',{staticClass:"wrapper"},[_c('router-link',{attrs:{"to":_vm.route}},[_vm._t("image"),_vm._v(" "),_c('Button',{staticClass:"button",attrs:{"theme":_vm.theme ? _vm.theme : 'white'}},[_vm._t("default")],2)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc48b45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonWithImage.vue
// module id = null
// module chunks = 